@if (loading) {
  <div class="d-flex align-items-center gap-2 py-2 ps-2">
    <div class="spinner-border spinner-border-sm alfalaval-blue-color" role="status"></div>
    <span>Loading suppliers...</span>
  </div>
} @else if (error) {
  <div class="alert alert-danger py-1 px-2 my-1">{{ error }}</div>
} @else {
  <kendo-grid
    [data]="suppliers"
    [scrollable]="'none'">
    <kendo-grid-column field="supplierId" title="Supplier ID" [width]="120"></kendo-grid-column>    
    <kendo-grid-column field="isMainSupplier" title="Main Supplier" [width]="100">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.isMainSupplier ? 'YES' : 'NO' }}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="stockCode" title="Stock Code" [width]="100"></kendo-grid-column>        
    <kendo-grid-column field="legalEntity" title="Legal Entity" [width]="110"></kendo-grid-column>
    <kendo-grid-column field="legalEntityName" title="Legal Entity Name"></kendo-grid-column>
    <kendo-grid-column field="siteId" title="Site ID" [width]="80"></kendo-grid-column>
    <kendo-grid-column field="baseUOMCode" title="Base UOM" [width]="90"></kendo-grid-column>
    <kendo-grid-column field="supplierItemIdentification" title="Supplier Item ID" [width]="130"></kendo-grid-column>
    <kendo-grid-column field="lastModificationDateTime" title="Last Modified" [width]="160">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.lastModificationDateTime | date:'yyyy-MM-dd HH:mm:ss' }}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="" [width]="55">
      <ng-template kendoGridCellTemplate let-dataItem>
        <button class="btn btn-outline-secondary btn-sm" (click)="viewSupplier(dataItem)" title="View supplier">
          <i class="fa fa-magnifying-glass" aria-hidden="true"></i>
        </button>
      </ng-template>
    </kendo-grid-column>
  </kendo-grid>
}
